module.exports = __webpack_public_path__ + "img/enterprise-institution-6.899ab4dc.png";